import Radio from './Radio';

export default Radio;



// WEBPACK FOOTER //
// ./src/components/Radio/index.ts